import { lazy, Suspense } from 'react';
import { useMediaQuery } from '@crehana/react-hooks';
import { jsx as _jsx } from "react/jsx-runtime";
var GridScrollDesktop = /*#__PURE__*/lazy(function () {
  return import("./components/GridScrollDesktop");
});
var GridScrollMobile = /*#__PURE__*/lazy(function () {
  return import("./components/GridScrollMobile");
});
var GridScroll = function GridScroll(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    className = _ref.className,
    children = _ref.children;
  var _useMediaQuery = useMediaQuery('md'),
    isMd = _useMediaQuery.matches;
  return /*#__PURE__*/_jsx(Suspense, {
    children: isMd ? /*#__PURE__*/_jsx(GridScrollDesktop, {
      items: items,
      className: className,
      children: children
    }) : /*#__PURE__*/_jsx(GridScrollMobile, {
      items: items,
      className: className,
      children: children
    })
  });
};
export default GridScroll;